<div class="container-fluid px-lg-5">
  <div class="row">
    <div class="col-12">
      <nav class="navbar navbar-expand-sm">
        <a class="navbar-brand" (click)="OnLogoClick()">
          <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </a>

        <ul class="nav ml-auto">
          <li><a class="pl-4" (click)="OnLogoClick()">Need&nbsp;Help</a></li>

          <li>
            <a class="pl-4" routerLink="/logout" routerLinkActive="active">Logout</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <!-- <div class="row"> -->
  <!-- <div class="col-8">
      <nav class="navbar navbar-expand-lg ">
          <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
      </nav>
  </div> -->
  <!-- <div class="col-2 mainlogout">
      <a class="logout" routerLink="/logout" routerLinkActive="active">Logout</a>
  </div> -->
  <!-- <div class="col-4">
          <ul class="navbar nav-right">
            <li><a class="getHelp">Need&nbsp;Help</a></li>

        <li>
            <a class="logout" routerLink="/logout" routerLinkActive="active">Logout</a>
      </li>
      </ul>
  </div> -->
  <!-- </div> -->
</div>
